import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';

export default function useLocationsSettingsTheme() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return useMemo(() => {
    const surface = isDark ? '#0f172a' : '#ffffff';
    const surface2 = isDark ? 'rgba(15, 23, 42, 0.72)' : 'rgba(255, 255, 255, 0.7)';
    const text = isDark ? '#e5e7eb' : '#0f172a';
    const muted = isDark ? '#94a3b8' : '#64748b';
    const border = isDark ? 'rgba(148, 163, 184, 0.22)' : 'rgba(15, 23, 42, 0.12)';
    const shadow = isDark ? '0 10px 30px rgba(0,0,0,0.35)' : '0 10px 30px rgba(2, 6, 23, 0.08)';
    const inputBg = isDark ? 'rgba(2, 6, 23, 0.35)' : 'rgba(255, 255, 255, 0.9)';
    const inputBgFocus = isDark ? 'rgba(2, 6, 23, 0.55)' : '#ffffff';
    const shimmerA = isDark ? 'rgba(226, 232, 240, 0.08)' : 'rgba(15, 23, 42, 0.06)';
    const shimmerB = isDark ? 'rgba(226, 232, 240, 0.14)' : 'rgba(15, 23, 42, 0.12)';

    return {
      '--bi-surface': surface,
      '--bi-surface-2': surface2,
      '--bi-text': text,
      '--bi-muted': muted,
      '--bi-border': border,
      '--bi-shadow': shadow,
      '--bi-focus': 'rgba(72, 138, 236, 0.45)',
      '--bi-input-bg': inputBg,
      '--bi-input-bg-focus': inputBgFocus,
      '--bi-shimmer-a': shimmerA,
      '--bi-shimmer-b': shimmerB,
    };
  }, [isDark]);
}
